import { type FanShopProductVariant } from '@capsicum/common';
import { CardCarousel, useRouter } from '@capsicum/common-web';

import { ProductCard } from '../product-card/ProductCard';

type RewardCardCarouselProps = {
	products: Array<FanShopProductVariant>;
};

export const CARD_WIDTH = 64;

export function RewardCardCarousel({ products }: RewardCardCarouselProps) {
	const { push } = useRouter();

	return (
		<CardCarousel cardWidth={CARD_WIDTH} testID="rewardCarousel" variant="fullWidth">
			{products?.map(product => (
				<ProductCard
					key={product.id}
					testID={`partner-productVariant-${product.id}`}
					variant={product}
					onClick={() => push(`/fan-shop/rewards/products/${product.id}`)}
				/>
			))}
		</CardCarousel>
	);
}
